import { FlaskConical } from "lucide-react";
import { useAppName } from "@/features/auth/session.ts";
import { cn } from "@/lib/cn.ts";

/**
 * The original DashME mark: three agent nodes converging into one workspace, on the brand green. On Codvero Lab a
 * flask in a white circle sits on its lower corner, so the two installations are told apart at a glance.
 */
export function LogoMark({ className, size = 36 }: { className?: string; size?: number }) {
  const lab = useAppName() === "Codvero Lab";
  const mark = (
    <svg viewBox="0 0 160 160" width={size} height={size} className={cn("shrink-0", !lab && className)} aria-hidden>
      <rect width="160" height="160" rx="40" fill="#0F6E56" />
      <rect x="90" y="60" width="42" height="42" rx="13" fill="none" stroke="#ffffff" strokeWidth="10" />
      <path d="M39 58 L81 72" fill="none" stroke="#5DCAA5" strokeWidth="6" strokeLinecap="round" />
      <path d="M39 80 L81 80" fill="none" stroke="#5DCAA5" strokeWidth="6" strokeLinecap="round" />
      <path d="M39 102 L81 88" fill="none" stroke="#5DCAA5" strokeWidth="6" strokeLinecap="round" />
      <circle cx="30" cy="56" r="8" fill="#9FE1CB" />
      <circle cx="30" cy="80" r="8" fill="#9FE1CB" />
      <circle cx="30" cy="104" r="8" fill="#9FE1CB" />
    </svg>
  );
  if (!lab) return mark;
  const badge = Math.max(14, Math.round(size * 0.5));
  return (
    <span className={cn("relative inline-block shrink-0", className)} style={{ width: size, height: size }}>
      {mark}
      {/* lower right, whatever the page's direction */}
      <span className="absolute grid place-items-center rounded-full bg-white shadow ring-2 ring-bg" style={{ width: badge, height: badge, right: -badge * 0.28, bottom: -badge * 0.28 }}>
        <FlaskConical className="text-[#0F6E56]" style={{ width: badge * 0.62, height: badge * 0.62 }} strokeWidth={2.4} />
      </span>
    </span>
  );
}
